import styled, { css } from 'styled-components';
import { media, layout } from 'src/components/base';
import CampaignGroup from './components/campaign-group';

export const flexStyle = css`
  min-width: 0;
  flex: 1 1 auto;

  ${media.largeUp`
    flex: 1 1 0%;
  `};
`;

export const gutterStyle = css`
  padding-left: ${layout.measurements.spacing050};
  padding-right: ${layout.measurements.spacing050};
`;

export const dividerStyle = css`
  margin-top: ${layout.measurements.spacing200};

  ${media.mediumDown`
    margin-top: ${layout.measurements.spacing050};
  `};
`;

export const StyledGutterWrapper = styled.div`
  ${flexStyle}
  ${gutterStyle}
`;

export const StyledCampaign = styled.section.attrs({
  'data-test': 'CampaignSection',
})`
  background: ${p => p.theme.colors.base0};
`;

export const StyledProductWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const StyledProducts = styled.section`
  ${flexStyle}
`;

export const StyledCampaignGrouping = styled(CampaignGroup)`
  ${gutterStyle}
  padding-top: ${layout.measurements.spacing100};
  padding-bottom: ${layout.measurements.spacing100};
`;
